import { useTheme } from 'styled-components';

export const PlusIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg className={className} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.36842 0V3.36842H0V4.63158H3.36842V8H4.63158V4.63158H8V3.36842H4.63158V0H3.36842Z"
        fill={theme.secondary.softBlue1}
      />
    </svg>
  );
};
